import React from 'react'
import { useSelector } from 'react-redux'

import { Case } from '@debbie/common/dist/cases/index.js'
import { getDocumentsThatExtendExpiration } from '@debbie/common/dist/documents/index.js'
import { Panel, PlaceholderLoader } from '@debbie/iris/dist/components/index.js'
import CaseVouchers from '@debbie/iris/dist/components/economy/case-vouchers/CaseVouchers.js'
import { DecoratedVoucher } from '@debbie/iris/dist/components/economy/case-vouchers/types.js'
import CaseBilling from '@debbie/iris/dist/components/economy/CaseBilling/index.js'
import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js'
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js'
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js'

import { CaseEconomyHeader } from './index.js'
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { TenantType } from '@debbie/common/dist/tenants/index.js'
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js'

type Props = {
  case?: Case | null
  id: string
}

const CaseEconomy = (props: Props) => {
  const singleCase = props.case
  const tenantId = useSelector(selectTenantId)
  const tenant = useSelector(selectTenant)

  const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId, {
    getDeleted: APCOA_EI_TENANT_IDS.includes(tenantId!),
  })

  const documentsLoadable = useDocumentsByReference(singleCase?.caseId)
  const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null

  const caseVouchers =
    h.hasData(caseVouchers_) &&
    caseVouchers_.data.map((caseVoucher): DecoratedVoucher => {
      return { ...caseVoucher, children: [] }
    })

  if (!documents) return null

  const foundations = documents && getDocumentsThatExtendExpiration(documents)

  return (
    <Panel
      header={
        caseVouchers && singleCase ? (
          <CaseEconomyHeader
            foundations={foundations}
            caseVouchers={caseVouchers}
            singleCase={singleCase}
          />
        ) : (
          ''
        )
      }
    >
      {singleCase && caseVouchers ? (
        <>
          <CaseVouchers caseVouchers={caseVouchers} singleCase={singleCase} />
          {tenant?.type === TenantType.Agency && (
            <>
              <hr />
              <CaseBilling
                tenantId={singleCase.tenantId}
                caseId={singleCase.caseId}
                creditorId={singleCase.creditorId}
                currency={singleCase.currency}
              />
            </>
          )}
        </>
      ) : (
        <PlaceholderLoader />
      )}
    </Panel>
  )
}

export default CaseEconomy
